import { render } from "./SellersInformation.vue?vue&type=template&id=387a1b14"
import script from "./SellersInformation.vue?vue&type=script&lang=js"
export * from "./SellersInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__